import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const TotalClaimAmountInPast3Years = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        Total Claim Amount in past 3 years *
      </Col>
      <Col sm={7}>
        <FormControl type="text" name="totalClaimAmountInPast3Years" value={props.totalClaimAmountInPast3Years} onChange={props.handleChangeTotalClaimAmountInPast3Years}
        required={props.required}
        disabled={props.disabled}
        autoComplete="off"
        onBlur={() => props.validation(true)} />
      </Col>
    </FormGroup>
  )
}

TotalClaimAmountInPast3Years.propTypes = {
  totalClaimAmountInPast3Years: PropTypes.number,
  handleChangeTotalClaimAmountInPast3Years: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  validation: PropTypes.func
};

TotalClaimAmountInPast3Years.defaultProps = {
  disabled: false,
  required: false
};

export default TotalClaimAmountInPast3Years;



// WEBPACK FOOTER //
// ./src/app/components/totalClaimAmountInPast3Years/TotalClaimAmountInPast3Years.js